import eotwJSXFactory from "base/eotwJSXFactory";
import GlobalEvents from "base/GlobalEvents";

// import $ from "jquery";
import "jquery-serializejson";
import svg4everybody from "svg4everybody";
import "objectFitPolyfill";
import "settings";

window.$ = jQuery;

import Page from "webPage/Page";

import Gallery from "Gallery";
import DealerResources from "DealerResources";
import PostModal from "modal/PostModal";
import PageNavigation from "./PageNavigation";

$(function () {
    if (window.jsLoadTimeout) {
        clearTimeout(window.jsLoadTimeout);
    }

    document.documentElement.setAttribute('data-useragent', navigator.userAgent);
    if (!!window.MSInputMethodContext && !!document.documentMode) {
        $('html').addClass('ie11');
    }

    svg4everybody();

    Page.init();

    $('body').on('click', '.js-language-dropdown', function () {
        $(this).parent().toggleClass('language-dropdown--open');
        return false;
    }).on('click', '.js-dropdown-toggle', function () {
        $(this).parents('.nav__item').find('.nav-dropdown').toggleClass('nav-dropdown--active');

        if ($(window).width() < 960) {
            return false;
        }
    }).on('click', '.js-menu-btn', function () {
        $('body').toggleClass('nav-active');
    }).on('click', '.js-mobile-menu-close', function () {
        $('body').removeClass('nav-active');
    }).on('click', '.js-open-compare-modal', function () {
        $('body').addClass('body-show-modal');
        $('.js-compare-modal').addClass('modal--active');
        return false;
    }).on('click', '.js-show-consumables-modal', function () {
        $('body').addClass('body-show-modal');
        $('.js-consumables-modal').addClass('modal--active');
        return false;
    }).on('click', '.js-show-modal', function () {
        $('body').addClass('body-show-modal');
        let modal = $(this).attr('data-modal');
        $('.js-modal[data-modal="' + modal + '"]').addClass('modal--active');
        return false;
    }).on('click', '.js-close-modal', function () {
        $('body').removeClass('body-show-modal');
        $(this).parents('.modal--active').removeClass('modal--active');
        return false;
    }).on('click', '.js-open-filter', function () {
        $('body').addClass('show-filter');
        return false;
    }).on('click', '.js-toggle-search', function () {
        $('body').toggleClass('body-search-active');

        if ($('body').is('.body-search-active')) {
            $('.js-search input').focus();
        }
        return false;
    }).on('click', '.js-close-search', function () {
        $('body').toggleClass('body-search-active');
        return false;
    }).on('click', '.js-show-share-icons', function () {
        $(this).parents().find('.news-card__share-icons').toggleClass('news-card__share-icons--active');
        return false;
    }).on('click', '.js-case-study-modal', function () {
        (new PostModal($(this).attr('data-post-id'), $(this).attr('data-post-type'))).show();
        return false;
    }).on('click', function (e) {
        if ($(e.target).closest('.js-language-dropdown').length === 0) {
            $('.js-language-dropdown').parent().removeClass('language-dropdown--open');
        }
    });

    if ($('.js-slider').length > 0) {
        $('.js-slider').each(function () {
            new Gallery($(this), {
                itemClass: "slider__item", pipClass: "pips__btn", navigateClass: "js-navigate", pipsClass: "js-pips", itemsClass: "js-slider-wrap", itemActiveModifier: "active", animationDuration: 0,
            });
        })
    }

    if ($('.js-gallery').length > 0) {
        $('.js-gallery').each(function () {
            let gallery = new Gallery($(this), {
                itemClass: "gallery__item", pipClass: "pips__btn", navigateClass: "js-navigate", pipsClass: "js-pips", itemsClass: "js-gallery-wrap", itemActiveModifier: "active", animationDuration: 0,
            });

            gallery.on('transitionEnd', ({from, to, direction}) => {
                gallery.$gallery.find('.js-current-slide').text(to + 1);
            });
        });
    }

    let $dealerResources = $('.js-dealer-resources');
    if ($dealerResources.length > 0) {
        new DealerResources($dealerResources);
    }

    let $pageNavigation = $('.js-page-navigation');
    if ($pageNavigation.length > 0) {
        new PageNavigation($pageNavigation);
    }

    handleAccordionSections();
    handleFilterSections();
    handleStickyTableHeaders();

    $('body').on('change', '.js-conditional-value', function () {
        let $this = $(this);
        let $parent = $this.parents('.js-conditional-logic');
        let value = $this.val();

        if (value === 'new') {
            value = 'all';
        } else {
            value = 'replacement';
        }

        $parent.find('.js-optional-section').hide();
        $parent.find('.js-optional-section[data-value="all"],.js-optional-section[data-value="' + value + '"]').show();
    }).on('change', '.js-model-value', function () {
        let $this = $(this);
        let $parent = $this.parents('.js-optional-section');
        let value = $this.val();

        if (value === 'Other') {
            $parent.find('.js-optional-field').show();
        } else {
            $parent.find('.js-optional-field').hide();
        }
    });

    $(document).on('gform_confirmation_loaded', function (event, formId) {
        try {
            if (formId === 20 /* Contact Form */) {
                window.lintrk('track', { conversion_id: 14293018 });
            }
        } catch (e) {
            console.log(e);
        }
    });

});

function handleStickyTableHeaders() {
    $('.js-sticky-heading-table').each((_, el) => {
        handleStickyTableHeader($(el));
    });
}

function handleStickyTableHeader($element) {
    let $header = $element.find('.js-sticky-heading');

    $(window).on('scroll', function () {
        let scrollTop = $(window).scrollTop();
        let tableOffset = $element.offset().top;

        let headerOffset = Math.abs(Math.min(tableOffset - scrollTop, 0));

        let maxOffset = $element.height() - $header.outerHeight() - 40;

        headerOffset = Math.min(headerOffset, maxOffset);

        $header.css({'margin-top': headerOffset + 'px'});
    });

    $(window).on('resize', function () {
        $header.css({'margin-top': 0 + 'px'});
    });
}

function handleFilterSections() {
    $(".js-filter-accordion").each((_, el) => {
        handleFilterSection($(el));
    });
}

function handleFilterSection($element) {
    $element.on("click", ".js-toggle-accordion", function () {
        let $faq = $(this).parent();
        $faq.toggleClass("filter__dropdown--open");

        return false;
    });
}

function handleAccordionSections() {
    $(".js-accordion").each((_, el) => {
        handleAccordionSection($(el));
    });
}

function handleAccordionSection($element) {
    $element.on("click", ".js-toggle-accordion", function () {
        let $faq = $(this).closest(".accordion__item");
        $faq.toggleClass("accordion__item--open");
        $faq.find('.accordion__panel').stop().slideToggle();

        return false;
    });
}

export function svg_include(icon, suffix = '') {
    return '<svg><use xlink:href="/wp-content/themes/avery-berkel-core/includes/svg-icons.svg?#' + icon + '"></use></svg>';
}

window.gformEotWAddRepeaterItem = function (addButton, max) {

    var $addButton = jQuery(addButton);
    console.log('here');

    if ($addButton.hasClass('gfield_icon_disabled')) {
        return;
    }

    var $item = $addButton.parents('.gfield_repeater_wrapper').find('.gfield_repeater_items .gfield_repeater_item:last-child'), $clone = $item.clone(), $container = $item.closest('.gfield_repeater_container'), tabindex = $clone.find(':input:last').attr('tabindex');

    // reset all inputs to empty state
    $clone
        .find('input[type!="hidden"], select, textarea').attr('tabindex', tabindex)
        .not(':checkbox, :radio').val('');
    $clone.find(':checkbox, :radio').prop('checked', false);
    $clone.find('.validation_message').remove();

    $clone = gform.applyFilters('gform_repeater_item_pre_add', $clone, $item);

    $clone.find('.js-optional-section').hide();
    $clone.find('.js-optional-field').hide();

    $item.after($clone);

    var $cells = $clone.children('.gfield_repeater_cell');
    $cells.each(function () {
        var $subContainer = jQuery(this).find('.gfield_repeater_container').first();
        if ($subContainer.length > 0) {
            resetContainerItems = function ($c) {
                $c.children('.gfield_repeater_items').children('.gfield_repeater_item').each(function (i) {
                    var $children = jQuery(this).children('.gfield_repeater_cell');
                    $children.each(function () {
                        var $subSubContainer = jQuery(this).find('.gfield_repeater_container').first();
                        if ($subSubContainer.length > 0) {
                            resetContainerItems($subSubContainer);
                        }
                    })
                })
                $c.children('.gfield_repeater_items').children('.gfield_repeater_item').not(':first').remove();
            }
            resetContainerItems($subContainer);
        }
    })

    gformResetRepeaterAttributes($container);

    if (typeof gformInitDatepicker == 'function') {
        $container.find('.ui-datepicker-trigger').remove();
        $container.find('.hasDatepicker').removeClass('hasDatepicker');
        gformInitDatepicker();
    }

    gformBindFormatPricingFields();

    gformToggleRepeaterButtons($container, max);

    var groupCount = $container.children('.gfield_repeater_items').children('.gfield_repeater_item').length;
    var $buttonsContainer = $container.children('.gfield_repeater_items').children('.gfield_repeater_item').children('.gfield_repeater_buttons');
    $buttonsContainer.css('display', groupCount == 1 ? 'none' : 'block');

    gform.doAction('gform_repeater_post_item_add', $clone, $container);
}

window.eotwJSXFactory = eotwJSXFactory;
window.GlobalEvents = GlobalEvents;